<template>
  <div class="container mx-auto">
    <div class="fixed right-20 z-40" v-if="alertOpen">
      <div
        class="text-white px-6 py-4 border-0 rounded relative mb-4 inline-grid grid-cols-1"
        :class="{ 'bg-red-500': !successMessage, 'bg-primary': successMessage }"
      >
        <span class="text-xl inline-block mr-5 align-middle">
          <i class="fas fa-bell"></i>
        </span>
        <span class="inline-block align-middle mr-8">
          <b class="capitalize"></b>
          <ul class="list-disc normal-case" v-if="successMessage">
            <li>{{ successMessage }}</li>
          </ul>
        </span>
        <span class="align-middle mr-0" v-for="ms in msg" :key="ms">
          <b class="capitalize"></b>
          <ul class="list-disc first-letter:capitalize mr-8">
            <li>{{ ms }}</li>
          </ul>
        </span>
        <button
          class="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-auto mt-4 mr-6 outline-none focus:outline-none"
          v-on:click="closeAlert()"
        >
          <span>×</span>
        </button>
      </div>
    </div>
    <div class="mb-8">
      <p class="text-[28px] font-bold">Account Settings</p>
    </div>
    <div class="flex flex-col gap-6 w-full">
      <div class="card flex flex-col items-center w-full rounded-[5px]">
        <div class="">
          <div
            class="flex items-center flex-wrap bg-white shadow-lg shadow-gray-300 rounded-full w-36 h-36"
          >
            <img
              v-if="oldData.previewImage && !previewImageCurrent"
              :src="oldData.previewImage"
              class="rounded-full w-full h-full object-cover"
            />
            <img
              v-if="previewImageCurrent"
              :src="previewImageCurrent"
              class="rounded-full w-full h-full object-cover"
            />
            <svg
              v-if="!previewImageCurrent && !oldData.previewImage"
              class="flex items-center justify-center mx-auto w-[95%] h-[95%]"
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 35 35"
            >
              <g
                id="Group_16106"
                data-name="Group 16106"
                transform="translate(-683 -223)"
              >
                <circle
                  id="Ellipse_1210"
                  data-name="Ellipse 1210"
                  cx="17.5"
                  cy="17.5"
                  r="17.5"
                  transform="translate(683 223)"
                  fill="none"
                  opacity="0.3"
                />
                <g
                  id="user_3_"
                  data-name="user (3)"
                  transform="translate(690 231)"
                >
                  <path
                    id="Path_25867"
                    data-name="Path 25867"
                    d="M10.9,9.8A4.9,4.9,0,1,0,6,4.9a4.9,4.9,0,0,0,4.9,4.9Zm0-8.167A3.267,3.267,0,1,1,7.633,4.9,3.267,3.267,0,0,1,10.9,1.633Z"
                    transform="translate(-0.55)"
                  />
                  <path
                    id="Path_25868"
                    data-name="Path 25868"
                    d="M10.35,14A7.358,7.358,0,0,0,3,21.35a.817.817,0,1,0,1.633,0,5.717,5.717,0,1,1,11.433,0,.817.817,0,0,0,1.633,0A7.358,7.358,0,0,0,10.35,14Z"
                    transform="translate(0 -2.567)"
                  />
                </g>
              </g>
            </svg>
            <div class="">
              <label
                for="upload"
                class="w-6 h-6 flex justify-center items-center relative inset-x-24 -inset-y-4 bg-primary rounded-full py-0 my-0 text-white"
                >+</label
              >
              <input type="file" id="upload" @change="uploadImage" hidden />
            </div>
          </div>
        </div>
        <div class="flex flex-col items-center w-full mt-8">
          <div class="w-1/2">
            <label class="relative p-0 my-2 w-full text-gray-400 bg-white">
              <!-- <img
                src="../../assets/SVGs/CharacterSVG.svg"
                class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3"
              /> -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11.999"
                height="15.999"
                viewBox="0 0 11.999 15.999"
                class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3 "
              >
                <g id="user_3_" data-name="user (3)" transform="translate(-3)">
                  <path
                    id="Path_25867"
                    data-name="Path 25867"
                    d="M10,8A4,4,0,1,0,6,4a4,4,0,0,0,4,4Zm0-6.666A2.666,2.666,0,1,1,7.333,4,2.666,2.666,0,0,1,10,1.333Z"
                    transform="translate(-1)"
                    fill="#adadad"
                  />
                  <path
                    id="Path_25868"
                    data-name="Path 25868"
                    d="M9,14a6.006,6.006,0,0,0-6,6,.667.667,0,1,0,1.333,0,4.666,4.666,0,1,1,9.333,0A.667.667,0,1,0,15,20,6.006,6.006,0,0,0,9,14Z"
                    transform="translate(0 -4.667)"
                    fill="#adadad"
                  />
                </g>
              </svg>
              <input
                class="block px-4 w-full pl-12 bg-inputbg appearance-none border-none rounded-[5px] h-14 text-black leading-tight focus:outline-none focus:bg-gray-200"
                type="text"
                placeholder="First Name"
                v-model="oldData.first_name"
              />
            </label>
          </div>
          <div class="w-1/2">
            <label class="relative p-0 my-2 w-full text-gray-400 bg-white">
              <!-- <img
                src="../../assets/SVGs/CharacterSVG.svg"
                class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3"
              /> -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11.999"
                height="15.999"
                viewBox="0 0 11.999 15.999"
                class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3"
              >
                <g id="user_3_" data-name="user (3)" transform="translate(-3)">
                  <path
                    id="Path_25867"
                    data-name="Path 25867"
                    d="M10,8A4,4,0,1,0,6,4a4,4,0,0,0,4,4Zm0-6.666A2.666,2.666,0,1,1,7.333,4,2.666,2.666,0,0,1,10,1.333Z"
                    transform="translate(-1)"
                    fill="#adadad"
                  />
                  <path
                    id="Path_25868"
                    data-name="Path 25868"
                    d="M9,14a6.006,6.006,0,0,0-6,6,.667.667,0,1,0,1.333,0,4.666,4.666,0,1,1,9.333,0A.667.667,0,1,0,15,20,6.006,6.006,0,0,0,9,14Z"
                    transform="translate(0 -4.667)"
                    fill="#adadad"
                  />
                </g>
              </svg>
              <input
                class="block w-full px-4 pl-12 bg-inputbg appearance-none border-none rounded-[5px] h-14 text-black leading-tight focus:outline-none focus:bg-gray-200"
                type="text"
                placeholder="Last Name"
                v-model="oldData.last_name"
              />
            </label>
          </div>
          <div class="w-1/2">
            <label class="relative p-0 my-2 w-full text-gray-400 bg-white">
              <!-- <img
                src="../../assets/SVGs/MobileSVG.svg"
                class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3"
              /> -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10.076"
                height="15.115"
                viewBox="0 0 10.076 15.115"
                class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3"
              >
                <g id="smartphone" transform="translate(-4)">
                  <path
                    id="Path_26661"
                    data-name="Path 26661"
                    d="M10.927,0H7.149A3.153,3.153,0,0,0,4,3.149v8.817a3.153,3.153,0,0,0,3.149,3.149h3.779a3.153,3.153,0,0,0,3.149-3.149V3.149A3.153,3.153,0,0,0,10.927,0ZM7.149,1.26h3.779a1.889,1.889,0,0,1,1.889,1.889v6.927H5.26V3.149A1.889,1.889,0,0,1,7.149,1.26Zm3.779,12.6H7.149A1.889,1.889,0,0,1,5.26,11.966v-.63h7.557v.63A1.889,1.889,0,0,1,10.927,13.855Z"
                    fill="#adadad"
                  />
                  <circle
                    id="Ellipse_1292"
                    data-name="Ellipse 1292"
                    cx="0.528"
                    cy="0.528"
                    r="0.528"
                    transform="translate(8.51 11.947)"
                    fill="#adadad"
                  />
                </g>
              </svg>
              <input
                class="block w-full px-4 pl-12 bg-inputbg appearance-none border-none rounded-[5px] h-14 my-2 text-black leading-tight focus:outline-none focus:bg-gray-200"
                type="text"
                placeholder="Mobile Number"
                v-model="oldData.mobile"
              />
            </label>
          </div>
          <div class="w-1/2">
            <label class="relative p-0 my-2 w-full text-gray-400 bg-white">
              <!-- <img
                src="../../assets/SVGs/MailSVG.svg"
                class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3"
              /> -->
              <svg
                class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3"
                xmlns="http://www.w3.org/2000/svg"
                width="12.659"
                height="11.604"
                viewBox="0 0 12.659 11.604"
              >
                <path
                  id="envelope_2_"
                  data-name="envelope (2)"
                  d="M10.022,1H2.637A2.64,2.64,0,0,0,0,3.637v6.33A2.64,2.64,0,0,0,2.637,12.6h7.384a2.64,2.64,0,0,0,2.637-2.637V3.637A2.64,2.64,0,0,0,10.022,1ZM2.637,2.055h7.384a1.582,1.582,0,0,1,1.466,1L7.449,7.09a1.586,1.586,0,0,1-2.239,0L1.171,3.05a1.582,1.582,0,0,1,1.466-1Zm7.384,9.494H2.637A1.582,1.582,0,0,1,1.055,9.967V4.428l3.41,3.407a2.641,2.641,0,0,0,3.73,0L11.6,4.428V9.967A1.582,1.582,0,0,1,10.022,11.549Z"
                  transform="translate(0 -1)"
                  fill="#adadad"
                />
              </svg>
              <input
                class="block pl-12 w-full px-4 bg-inputbg appearance-none border-none rounded-[5px] h-14 my-2 text-black leading-tight focus:outline-none focus:bg-gray-200"
                type="text"
                placeholder="Your Email"
                v-model="oldData.email"
              />
            </label>
          </div>
        </div>
        <div class="mt-4">
          <button
            class="bg-primary text-white p-2 px-6 rounded-[5px]"
            @click="submit"
          >
            Save Changes
          </button>
        </div>
      </div>
      <div class="card flex flex-col items-center rounded-[5px]">
        <div class="flex justify-start items-start flex-row">
          <p class="text-[21px] font-medium mb-12">Update Your Password</p>
        </div>
        <div class="flex flex-col w-full justify-center items-center">
          <label class="relative p-0 my-2 md:w-[50%]">
            <!-- <img
              src="../../assets/SVGs/PasswordSVG.svg"
              class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3"
            /> -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11.833"
              height="14.2"
              viewBox="0 0 11.833 14.2"
              class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3"
            >
              <g id="lock" transform="translate(-2)">
                <path
                  id="Path_25415"
                  data-name="Path 25415"
                  d="M12.058,4.984V4.142a4.142,4.142,0,1,0-8.283,0v.843A2.958,2.958,0,0,0,2,7.692v3.55A2.962,2.962,0,0,0,4.958,14.2h5.917a2.962,2.962,0,0,0,2.958-2.958V7.692A2.958,2.958,0,0,0,12.058,4.984Zm-7.1-.843a2.958,2.958,0,1,1,5.917,0v.592H4.958Zm7.692,7.1a1.775,1.775,0,0,1-1.775,1.775H4.958a1.775,1.775,0,0,1-1.775-1.775V7.692A1.775,1.775,0,0,1,4.958,5.917h5.917A1.775,1.775,0,0,1,12.65,7.692Z"
                  transform="translate(0)"
                  fill="#adadad"
                />
                <path
                  id="Path_25416"
                  data-name="Path 25416"
                  d="M11.592,14a.592.592,0,0,0-.592.592v1.183a.592.592,0,1,0,1.183,0V14.592A.592.592,0,0,0,11.592,14Z"
                  transform="translate(-3.675 -5.717)"
                  fill="#adadad"
                />
              </g>
            </svg>
            <input
              class="block bg-inputbg pl-12 appearance-none border-none rounded-[5px] h-14 w-full py-2 text-black leading-tight focus:outline-none focus:shadow-outline"
              :type="[enable ? 'text' : 'password']"
              placeholder="New Password"
              v-model="password"
            />
            <!-- <img
              src="../../assets/SVGs/ShowSVG.svg"
              class="pointer w-8 h-8 absolute top-1/2 transform -translate-y-1/2 right-3 opacity-30"
              @click="enablePass()"
              v-if="enable == false"
            /> -->
            <svg
              class="pointer w-8 h-8 absolute top-1/2 transform -translate-y-1/2 right-3 opacity-30"
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 35 35"
              @click="enablePass()"
              v-if="enable == false"
            >
              <g
                id="Group_16847"
                data-name="Group 16847"
                transform="translate(-0.4)"
              >
                <path
                  id="eye-crossed"
                  d="M16.934,7.128a11.546,11.546,0,0,0-2.453-2.845l2.038-2.038a.728.728,0,1,0-1.029-1.029L13.274,3.435a8.772,8.772,0,0,0-4.542-1.23,9.64,9.64,0,0,0-8.2,4.922,3.572,3.572,0,0,0,0,3.757,11.546,11.546,0,0,0,2.453,2.845L.945,15.767A.728.728,0,1,0,1.974,16.8l2.221-2.221a8.772,8.772,0,0,0,4.537,1.232,9.64,9.64,0,0,0,8.2-4.922A3.572,3.572,0,0,0,16.934,7.128ZM1.769,10.122a2.124,2.124,0,0,1,0-2.233A8.238,8.238,0,0,1,8.732,3.661a7.35,7.35,0,0,1,3.468.848L10.735,5.973A3.633,3.633,0,0,0,5.7,11.009L4.018,12.691a9.987,9.987,0,0,1-2.249-2.568Zm9.146-1.116a2.183,2.183,0,0,1-2.183,2.183,2.148,2.148,0,0,1-.935-.218l2.9-2.9A2.148,2.148,0,0,1,10.915,9.006Zm-4.366,0A2.183,2.183,0,0,1,8.732,6.823a2.148,2.148,0,0,1,.935.218l-2.9,2.9a2.148,2.148,0,0,1-.218-.935Zm9.146,1.116a8.238,8.238,0,0,1-6.962,4.229A7.35,7.35,0,0,1,5.263,13.5l1.465-1.465A3.633,3.633,0,0,0,11.764,7l1.681-1.681A9.987,9.987,0,0,1,15.694,7.89a2.124,2.124,0,0,1,0,2.233Z"
                  transform="translate(8.768 8.494)"
                />
                <circle
                  id="Ellipse_1214"
                  data-name="Ellipse 1214"
                  cx="17.5"
                  cy="17.5"
                  r="17.5"
                  transform="translate(0.4)"
                  fill="none"
                  opacity="0.3"
                />
              </g>
            </svg>
            <!-- <img
              src="../../assets/SVGs/HideSVG.svg"
              class="pointer w-4 h-4 absolute top-1/2 transform -translate-y-1/2 right-5 opacity-30"
              v-if="enable == true"
              @click="enablePass()"
            /> -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15.315"
              height="11.923"
              viewBox="0 0 15.315 11.923"
              class="pointer w-4 h-4 absolute top-1/2 transform -translate-y-1/2 right-3 opacity-30"
              v-if="enable == true"
              @click="enablePass()"
            >
              <g id="eye" transform="translate(0.004 -2.655)">
                <path
                  id="Path_26662"
                  data-name="Path 26662"
                  d="M14.843,6.97a8.448,8.448,0,0,0-7.19-4.315A8.448,8.448,0,0,0,.463,6.97a3.131,3.131,0,0,0,0,3.293,8.448,8.448,0,0,0,7.19,4.315,8.448,8.448,0,0,0,7.19-4.315A3.131,3.131,0,0,0,14.843,6.97ZM13.756,9.595a7.217,7.217,0,0,1-6.1,3.707,7.217,7.217,0,0,1-6.1-3.707,1.861,1.861,0,0,1,0-1.957,7.217,7.217,0,0,1,6.1-3.707,7.212,7.212,0,0,1,6.1,3.707A1.861,1.861,0,0,1,13.756,9.595Z"
                  transform="translate(0 0)"
                />
                <path
                  id="Path_26663"
                  data-name="Path 26663"
                  d="M10.19,7a3.19,3.19,0,1,0,3.19,3.19A3.19,3.19,0,0,0,10.19,7Zm0,5.1A1.914,1.914,0,1,1,12.1,10.19,1.914,1.914,0,0,1,10.19,12.1Z"
                  transform="translate(-2.536 -1.573)"
                />
              </g>
            </svg>
          </label>
          <label class="relative p-0 my-2 md:w-[50%]">
            <!-- <img
              src="../../assets/SVGs/PasswordSVG.svg"
              class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3"
            /> -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11.833"
              height="14.2"
              viewBox="0 0 11.833 14.2"
              class="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3"
            >
              <g id="lock" transform="translate(-2)">
                <path
                  id="Path_25415"
                  data-name="Path 25415"
                  d="M12.058,4.984V4.142a4.142,4.142,0,1,0-8.283,0v.843A2.958,2.958,0,0,0,2,7.692v3.55A2.962,2.962,0,0,0,4.958,14.2h5.917a2.962,2.962,0,0,0,2.958-2.958V7.692A2.958,2.958,0,0,0,12.058,4.984Zm-7.1-.843a2.958,2.958,0,1,1,5.917,0v.592H4.958Zm7.692,7.1a1.775,1.775,0,0,1-1.775,1.775H4.958a1.775,1.775,0,0,1-1.775-1.775V7.692A1.775,1.775,0,0,1,4.958,5.917h5.917A1.775,1.775,0,0,1,12.65,7.692Z"
                  transform="translate(0)"
                  fill="#adadad"
                />
                <path
                  id="Path_25416"
                  data-name="Path 25416"
                  d="M11.592,14a.592.592,0,0,0-.592.592v1.183a.592.592,0,1,0,1.183,0V14.592A.592.592,0,0,0,11.592,14Z"
                  transform="translate(-3.675 -5.717)"
                  fill="#adadad"
                />
              </g>
            </svg>

            <input
              :class="[Checkistwins ? 'text-black' : 'text-red-500 ']"
              class="block bg-inputbg pl-12 appearance-none border-none rounded-[5px] h-14 w-full py-2 text-black leading-tight focus:outline-none focus:shadow-outline"
              :type="[_enable ? 'text' : 'password']"
              placeholder="Confirm Password"
              v-model="confirmPassword"
            />
            <!-- <img
              src="../../assets/SVGs/ShowSVG.svg"
              class="pointer w-8 h-8 absolute top-1/2 transform -translate-y-1/2 right-3 opacity-30"
              @click="enablePassV()"
              v-if="_enable == false"
            /> -->
            <svg
              class="pointer w-8 h-8 absolute top-1/2 transform -translate-y-1/2 right-3 opacity-30"
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 35 35"
              @click="enablePassV()"
              v-if="_enable == false"
            >
              <g
                id="Group_16847"
                data-name="Group 16847"
                transform="translate(-0.4)"
              >
                <path
                  id="eye-crossed"
                  d="M16.934,7.128a11.546,11.546,0,0,0-2.453-2.845l2.038-2.038a.728.728,0,1,0-1.029-1.029L13.274,3.435a8.772,8.772,0,0,0-4.542-1.23,9.64,9.64,0,0,0-8.2,4.922,3.572,3.572,0,0,0,0,3.757,11.546,11.546,0,0,0,2.453,2.845L.945,15.767A.728.728,0,1,0,1.974,16.8l2.221-2.221a8.772,8.772,0,0,0,4.537,1.232,9.64,9.64,0,0,0,8.2-4.922A3.572,3.572,0,0,0,16.934,7.128ZM1.769,10.122a2.124,2.124,0,0,1,0-2.233A8.238,8.238,0,0,1,8.732,3.661a7.35,7.35,0,0,1,3.468.848L10.735,5.973A3.633,3.633,0,0,0,5.7,11.009L4.018,12.691a9.987,9.987,0,0,1-2.249-2.568Zm9.146-1.116a2.183,2.183,0,0,1-2.183,2.183,2.148,2.148,0,0,1-.935-.218l2.9-2.9A2.148,2.148,0,0,1,10.915,9.006Zm-4.366,0A2.183,2.183,0,0,1,8.732,6.823a2.148,2.148,0,0,1,.935.218l-2.9,2.9a2.148,2.148,0,0,1-.218-.935Zm9.146,1.116a8.238,8.238,0,0,1-6.962,4.229A7.35,7.35,0,0,1,5.263,13.5l1.465-1.465A3.633,3.633,0,0,0,11.764,7l1.681-1.681A9.987,9.987,0,0,1,15.694,7.89a2.124,2.124,0,0,1,0,2.233Z"
                  transform="translate(8.768 8.494)"
                />
                <circle
                  id="Ellipse_1214"
                  data-name="Ellipse 1214"
                  cx="17.5"
                  cy="17.5"
                  r="17.5"
                  transform="translate(0.4)"
                  fill="none"
                  opacity="0.3"
                />
              </g>
            </svg>
            <!-- <img
              src="../../assets/SVGs/HideSVG.svg"
              class="pointer w-4 h-4 absolute top-1/2 transform -translate-y-1/2 right-5 opacity-30"
              v-if="_enable == true"
              @click="enablePassV()"
            /> -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15.315"
              height="11.923"
              viewBox="0 0 15.315 11.923"
              class="pointer w-4 h-4 absolute top-1/2 transform -translate-y-1/2 right-3 opacity-30"
              v-if="_enable == true"
              @click="enablePassV()"
            >
              <g id="eye" transform="translate(0.004 -2.655)">
                <path
                  id="Path_26662"
                  data-name="Path 26662"
                  d="M14.843,6.97a8.448,8.448,0,0,0-7.19-4.315A8.448,8.448,0,0,0,.463,6.97a3.131,3.131,0,0,0,0,3.293,8.448,8.448,0,0,0,7.19,4.315,8.448,8.448,0,0,0,7.19-4.315A3.131,3.131,0,0,0,14.843,6.97ZM13.756,9.595a7.217,7.217,0,0,1-6.1,3.707,7.217,7.217,0,0,1-6.1-3.707,1.861,1.861,0,0,1,0-1.957,7.217,7.217,0,0,1,6.1-3.707,7.212,7.212,0,0,1,6.1,3.707A1.861,1.861,0,0,1,13.756,9.595Z"
                  transform="translate(0 0)"
                />
                <path
                  id="Path_26663"
                  data-name="Path 26663"
                  d="M10.19,7a3.19,3.19,0,1,0,3.19,3.19A3.19,3.19,0,0,0,10.19,7Zm0,5.1A1.914,1.914,0,1,1,12.1,10.19,1.914,1.914,0,0,1,10.19,12.1Z"
                  transform="translate(-2.536 -1.573)"
                />
              </g>
            </svg>
          </label>
        </div>
        <div class="mt-4">
          <button
            :class="[
              password != confirmPassword && confirmPassword === null
                ? 'disabled:opacity-50'
                : '',
            ]"
            :disabled="password != confirmPassword"
            class="bg-primary text-white p-2 px-6 rounded-[5px] disabled"
            @click="changePassword"
          >
            Update Password
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "../../store";
import AlertPopup from "../../components/UI/AlertPopup.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: { AlertPopup },
  data() {
    return {
      enable: false,
      _enable: false,
      previewImageCurrent: "",
      data: "",
      oldData: {
        first_name: "",
        last_name: "",
        email: "",
        mobile: "",
        previewImage: "",
      },
      password: null,
      confirmPassword: null,
      msg: null,
      successMessage: null,
      alertOpen: false,
    };
  },
  async mounted() {
    //Change Document Title
    document.title = "dKilo Ad Manager - Profile";
    await this.getUserData();
  },
  computed: {
    Checkistwins() {
      if (this.confirmPassword === this.password) {
        return true;
      }
    },
    ...mapGetters(["getAllUserData"]),
    ...mapGetters(["getMsg"]),
    ...mapGetters(["getMessage"]),
  },

  methods: {
    closeAlert: function () {
      this.alertOpen = false;
    },
    enablePass() {
      this.enable = !this.enable;
    },
    enablePassV() {
      this._enable = !this._enable;
    },
    uploadImage(e) {
      const image = e.target.files[0];
      this.oldData.previewImage = image;

      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImageCurrent = e.target.result;
      };
    },

    async getUserData() {
      try {
        store.commit("toggleLoading");
        await store.dispatch("getUserData");
        this.oldData.first_name = this.getAllUserData.publisher.first_name;
        this.oldData.last_name = this.getAllUserData.publisher.last_name;
        this.oldData.mobile = this.getAllUserData.publisher.mobile;
        this.oldData.email = this.getAllUserData.publisher.email;
        this.oldData.previewImage = this.getAllUserData.profile_picture;
        store.commit("toggleLoading");
      } catch (error) {
        store.commit("toggleLoading");
      }

      //   this.previewImage = this.profile_picture;
      //     let token = localStorage.getItem("token");
      //     try {
      //         store.commit("toggleLoading");
      //         let apiUrl = "http://publish.test.dkilo.net/api/me";
      //         const res = await axios.get(apiUrl, {
      //             headers: { token: token },
      //         });
      //         this.first_name = res.data.publisher.first_name;
      //         this.last_name = res.data.publisher.last_name;
      //         this.email = res.data.publisher.email;
      //         this.mobile = res.data.publisher.mobile;
      //         this.previewImage = res.data.profile_picture;
      //         // console.log("pic", this.previewImage);
      //         store.commit("toggleLoading");
      //     } catch (error) {
      //         store.commit("toggleLoading");
      //     }
    },

    async submit() {
      //new
      store.commit("updateSavedChanges", this.oldData);
      try {
        store.commit("toggleLoading");
        await store.dispatch("saveChanges");
        store.commit("updataProfile_pic", res.data.profile_picture);
        localStorage.setItem("firstName", res.data.publisher.first_name);
        store.commit("updateFirstName");

        store.commit("toggleLoading");
      } catch (error) {
        store.commit("toggleLoading");
      }
      this.alertOpen = true;
      this.successMessage = this.getMessage;
      this.msg = this.getMsg;
      setTimeout(() => (this.alertOpen = false), 5000);
      setTimeout(() => {
        this.$store.commit("clearMessage");
      }, 5000);
      setTimeout(() => {
        this.$store.commit("clearResMessage");
      }, 5000);

      //old
      //   let token = localStorage.getItem("token");
      //   const formData = new FormData();
      //   formData.append("first_name", this.first_name);
      //   formData.append("last_name", this.last_name);
      //   formData.append("email", this.email);
      //   formData.append("mobile", this.mobile);
      //   formData.append("profile_picture", this.previewImage);

      //   let api = "http://publish.test.dkilo.net/api/edit";

      //   try {
      //     store.commit("toggleLoading");
      //     const res = await axios.post(api, formData, {
      //       headers: {
      //         token: token,
      //       },
      //     });
      //     // alert(res.data.message);
      //     this.msg = res.data.message;
      //     this.alertOpen = true;
      //     store.commit("updataProfile_pic", res.data.profile_picture);
      //     localStorage.setItem("firstName", res.data.publisher.first_name);
      //     store.commit("updateFirstName");

      //     setTimeout(() => (this.alertOpen = false), 5000);

      //     // location.reload();
      //     store.commit("toggleLoading");
      //   } catch (error) {
      //     store.commit("toggleLoading");
      //   }
    },
    async changePassword() {
      store.commit("changeCurrentPassword", this.password);
      try {
        store.commit("toggleLoading");
        await store.dispatch("changePassword");
        store.commit("toggleLoading");
      } catch (error) {
        store.commit("toggleLoading");
      }
      this.alertOpen = true;
      this.msg = this.getMsg;
      setTimeout(() => (this.alertOpen = false), 5000);
    },
  },
};
</script>

<style></style>
